<template>
  <div ref="isRead">
    <div v-show="!isRead" class="crumbs">
      <span class="el-icon-location" /><a class="lanmu" href="/home" target="_blank">首页</a><span>/</span><a class="lanmu" :href="'column?columnId='+list.columnCrumbs[0].COLUMN_ID+'&name='+list.columnCrumbs[0].COLUMN_NAME" target="_blank">{{ list.columnCrumbs[0].COLUMN_NAME }}</a><span>/正文</span>
    </div>
    <div class="box">
      <div ref="box" class="center">
        <!--<div class="title">-->
        <!--{{ list.cmsContent.CONTENT_TITLE }}-->
        <!--</div>-->
        <!--<div class="contentMsg">-->
        <!--<span>{{ list.cmsContent.CONTENT_ISSUE_DATE|changeTime }}</span><span class="author">{{ list.cmsContent.CONTENT_SOURCE_NAME }}</span><span>{{ list.cmsContent.CONTENT_AUTHOR }}</span>-->
        <!--</div>-->
        <!--<div v-if="list.cmsContent.CONTENT_ABSTRACT" class="abstract">-->
        <!--{{ list.cmsContent.CONTENT_ABSTRACT }}-->
        <!--</div>-->
        <!--<div v-if="list.cmsContent.CONTENT_PHOTO_SMALL" class="smallImg">-->
        <!--<img :src="list.cmsContent.CONTENT_PHOTO_SMALL" alt="">-->
        <!--</div>-->
        <div class="imgBox">
          <div class="shadowss" />
          <div class="title">
            {{ list.cmsContent.CONTENT_TITLE }}
          </div>
          <div class="contentMsg">
            <span>{{ list.cmsContent.CONTENT_ISSUE_DATE|changeTime }}</span><span class="author">{{ list.cmsContent.CONTENT_SOURCE_NAME }}</span><span>{{ list.cmsContent.CONTENT_AUTHOR }}</span>
          </div>
          <div v-if="list.cmsContent.CONTENT_ABSTRACT" class="abstract">
            {{ list.cmsContent.CONTENT_ABSTRACT }}
          </div>
          <img v-if="list.cmsContent.CONTENT_PHOTO_SMALL" :src="list.cmsContent.CONTENT_PHOTO_SMALL" alt="">
          <!--<img v-if="!list.cmsContent.CONTENT_PHOTO_SMALL" :src="defaultimg[randomimg]" alt="">-->
        </div>
        <iframe
          id="review"
          :src="'http://online.chinagen.cn/JointatTotemsOnline/online/onlineFile?path='+list.cmsDoc[0].DOC_URL"
          class="iframeSty"
        />
      </div>
      <div ref="share" class="share">
        <span>分享到:</span>
        <span class="icon" @click="weibo"><svg-icon icon-class="wb" /></span>
        <span class="icon" @click="qq"><svg-icon icon-class="qq" /></span>
        <span class="icon wxImg"><svg-icon icon-class="wx" /> <div id="qrcode" ref="qrcode" /></span>
        <div class="bdsharebuttonbox moreShare">
          <a href="#" class="bds_more el-icon-more" data-cmd="more" />
        </div>
        <span @click="shareImg"><i class="el-icon-share" /></span>
        <span class="btn" @click="shareImg">生成分享图片</span>
        <div class="rightbox">
          <span :class="list.collectionNOrNot?'collected':'nocollected'" @click="goshowcang"><svg-icon icon-class="shoucang" /></span>
          <span class="num">{{ list.cmsCollectionNumber }}</span>
          <span @click="gopinlun"><svg-icon icon-class="pinlun" /></span>
          <span class="num">{{ list.cmsSpeakInNumber }}</span>
          <a v-if="list.cmsContent.CONTENT_IS_DOWNLOAD==1" class="btnLoad" :href="list.cmsDoc[0].DOC_URL" download=""><svg-icon icon-class="xiazai" /></a>
          <span class="readBtn" @click="handleRead"><svg-icon icon-class="reading" /></span>
        </div>
      </div>
      <div class="gonext">
        <div v-if="list.nextLastContent.LAST_CONTENT_ID!=='0'" class="next" @click="goDetail(list.nextLastContent.LAST_CONTENT_ID)">
          <div class="imgbox">
            <img v-if="list.nextLastContent.LAST_CONTENT_IMG" :src="list.nextLastContent.LAST_CONTENT_IMG" alt="">
            <img v-else :src="noIMG" alt="">
          </div>
          <div class="imgShadow" />
          <p class="title">
            {{ list.nextLastContent.LAST_CONTENT_TITLE }}
          </p>
          <div class="time">
            <span class="goelse">&lt;&lt;上一篇</span><span class="times">{{ list.nextLastContent.LAST_CONTENT_DATE|changeTime }}</span>
          </div>
        </div>
        <div v-else class="next">
          <p style="text-align: center;height: 86px;line-height: 86px;font-size: 20px;color: #A19D9E;font-weight: 600;">
            已经到顶了
          </p>
        </div>
        <div class="next" @click="goDetail(list.nextLastContent.NEXT_CONTENT_ID)">
          <div class="imgbox">
            <img v-if="list.nextLastContent.NEXT_CONTENT_IMG" :src="list.nextLastContent.NEXT_CONTENT_IMG" alt="">
            <img v-else :src="noIMG" alt="">
          </div>
          <div class="imgShadow" />
          <p class="title">
            {{ list.nextLastContent.NEXT_CONTENT_TITLE }}
          </p>
          <div class="time">
            <span class="goelse">&gt;&gt;下一篇</span><span class="times">{{ list.nextLastContent.NEXT_CONTENT_DATE|changeTime }}</span>
          </div>
        </div>
      </div>
      <div class="likes">
        <div class="title">
          <span>猜你喜欢</span>
        </div>
        <div class="content">
          <Centerlistnews :columnlist="interestedHomeData" />
        </div>
      </div>
      <div class="bookShow">
        <div class="Booktitle">
          <span>推荐家谱</span>
        </div>
        <tuijianBook />
      </div>
      <!--<div class="speak">-->
      <!--<Speak :content-id="list.cmsContent.CONTENT_ID" />-->
      <!--</div>-->
    </div>
    <div v-show="shareImgShow==true" class="showBox">
      <div class="content">
        <canvas id="myCanvasNews" width="432" height="630" style="background-color: #fff;" />
        <div id="qrcode5" ref="qrcode5" style="display: none" />
        <div class="closeBtn" @click="handelClose">
          X
        </div>
      </div>
    </div>
    <div v-show="isRead" class="goback">
      <span @click="handelBack"><svg-icon icon-class="fanhui" /></span>
    </div>
  </div>
</template>
<script>
import Centerlistnews from '@/components/centerlist_atlas'
import Speak from '@/components/Detail_speak/index.vue'
import { InterestedHome, addCollect } from '@/api/api.js'
import tuijianBook from '@/views/components/sourceDetail_content/tuijianBookContent/index.vue'
export default {
  name: 'LibraryDetail',
  components: { Centerlistnews, Speak, tuijianBook },
  props: ['list'],
  data() {
    return {
      loginIMG: require('@/static/bg_txz.png'),
      tag: [],
      isshow: false,
      interestedHomeData: [],
      noIMG: require('@/static/home_noimg.png'),
      iscollect: false,
      shareImgShow: false,
      logoImage: require('@/static/logo_gengji22.png'),
      isRead: false
    }
  },
  computed: {
    item() {
      return {}
    }
  },
  asyncData({ store, route }) {
    // return store.dispatch('fetchItem', { id: route.params.id })
  },
  mounted() {
    // this.tag = this.list.cmsContent.CONTENT_TAG.split(',')
    window.scrollTo(0, 0)
    this.wx()
    this.wx2()
    this.canvasInit()
    // console.log(this.list.cmsDoc[0])
    window.addEventListener('scroll', this.handleScroll, true)
  },
  updated() {
    window.scrollTo(0, 0)
  },
  created() {
    InterestedHome().then(res => {
      this.interestedHomeData = res.data.cmsContent
    })
  },
  methods: {
    canvasInit() {
      var mycans = document.getElementsByTagName('canvas')[2]// 二维码所在的canvas
      var codeimg = convertCanvasToImage(mycans)

      // /第一个图
      var mycanvas = document.getElementById('myCanvasNews')
      var context = mycanvas.getContext('2d')
      var img1 = new Image()
      // img1.setAttribute('crossOrigin', 'Anonymous')
      img1.src = this.list.cmsContent.CONTENT_PHOTO_SMALL
      var img2 = new Image()
      // img2.setAttribute('crossOrigin', 'Anonymous')
      img2.src = this.logoImage
      var img3 = new Image()
      img3.src = this.loginIMG

      var title = this.list.cmsContent.CONTENT_TITLE
      var avstract = this.list.cmsContent.CONTENT_ABSTRACT
      function drawText(context, t, x, y, w) {
        var chr = t.split('')
        var temp = ''
        var row = []

        context.font = '20px Arial'
        context.fillStyle = '#a19d9e'
        context.textBaseline = 'middle'

        for (var a = 0; a < chr.length; a++) {
          if (context.measureText(temp).width < w && context.measureText(temp + (chr[a])).width <= w) {
            temp += chr[a] // context.measureText(text).width  测量文本text的宽度
          } else {
            row.push(temp)
            temp = chr[a]
          }
        }
        row.push(temp)

        // for (var b = 0; b < row.length; b++) {
        //   context.fillText(row[b], x, y + (b + 1) * 24)// 字体20，间隔24。类似行高
        // }

        // 只显示2行，加...
        for (var b = 0; b < 3; b++) {
          var str = row[b]
          if (b == 2) {
            str = str.substring(0, str.length - 1) + '...'
          }
          context.fillText(str, x, y + (b + 1) * 24)
        }
      }
      img3.onload = function() {
        context.drawImage(this, 0, 0, 432, 630)
        context.drawImage(codeimg, 280, 460, 100, 100)
        context.drawImage(img2, 30, 490, 173, 56)
        context.drawImage(img1, 0, 0, 436, 270)
        // 第二行文字
        context.textAlign = 'center'
        context.font = '27px Arial'
        context.fillStyle = '#333333'
        var title1 = title.slice(0, 15)
        context.fillText(title1, 216, 300)
        if (title.length > 15) {
          var title2 = title.substring(15)
          context.fillText(title2, 216, 340)
        }
        // /第三行文字
        context.textAlign = 'start'
        context.font = '18px Arial'
        context.fillStyle = '#a19d9e'
        if (avstract) {
          drawText(context, avstract, 10, 350, 410)
        }
      }
      // 画上二维码
      function convertCanvasToImage(canvas) {
        var image = new Image()
        image.src = canvas.toDataURL('image/png')
        return image
      }
    },
    handleScroll: function() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (this.$refs.share) {
        if (this.$refs.share.offsetTop + scrollTop - this.$refs.box.offsetHeight - 290 > 0) {
          this.$refs.share.style.position = 'relative'
        }
        if (scrollTop + window.innerHeight < this.$refs.box.offsetHeight + 300) {
          this.$refs.share.style.position = 'fixed'
          this.$refs.share.style.bottom = '0'
        }
      }
    },
    handelBack: function() {
      this.$emit('handelRead', false)
      this.isRead = false
    },
    handleRead: function() {
      this.isRead = true
      this.$emit('handelRead', true)
    },
    wx2: function() {
      const qrcode5 = new QRCode('qrcode5', {
        text: window.location.href,
        width: 100,
        height: 100,
        colorDark: '#000', // 黑色
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.H
      })
      qrcode5.makeCode(window.location.href)// 生成另一个新的二维码
    },
    handelClose: function() {
      this.shareImgShow = false
      this.$refs.share.style.display = 'block'
    },
    shareImg: function() {
      this.shareImgShow = true
      this.$refs.share.style.display = 'none'
    },
    goDetail: function(contentId) {
      if (contentId == 0) {
        this.$message({
          message: '暂时没有啦',
          type: 'warning'
        })
      } else {
        // this.$router.push({ path: '/Detail', query: { 'contentId': contentId }})
        const { href } = this.$router.resolve({
          path: '/Detail',
          name: 'dt',
          query: {
            contentId
          }
        })
        window.location.href = href
      }
    },
    gocloumn: function(id, name) {
      // this.$router.push({ name: 'column', params: { columnName: id }})
      window.location.href = '/column/?columnId=' + id
    },
    weibo: function() {
      console.log(1111)
      var p = {
        count: '1',
        url: window.location.href,
        // 用于发布微博的来源显示， 为空则分享的内容来源会显示来自互联网。(可选， 允许为空)
        appkey: '彭祖世家网',
        // 分享时所示的文字内容， 为空则自动抓取分享页面的title值(可选， 允许为空)
        title: this.list.cmsContent.CONTENT_TITLE,
        pic: this.list.cmsContent.CONTENT_PHOTO_SMALL,
        ralateUid: '',
        language: 'zh_cn'
      }
      var s = []
      for (var i in p) {
        s.push(i + '=' + encodeURIComponent(p[i] || ''))
      }
      var url = 'http://service.weibo.com/share/share.php?' + s.join('&')
      window.open(url, '_blank')
    },
    qq: function() {
      var p = {
        /* 获取URL，可加上来自分享到QQ标识，方便统计*/
        url: window.location.href,
        desc: '彭祖世家网',
        /* 分享标题(可选)*/
        title: this.list.cmsContent.CONTENT_TITLE,
        /* 分享摘要(可选)*/
        summary: this.list.cmsContent.CONTENT_ABSTRACT,
        /* 分享图片(可选)*/
        pics: 'this.list.cmsContent.CONTENT_PHOTO_SMALL',
        /* 视频地址(可选)*/
        flash: '',
        /* 分享来源(可选) 如：QQ分享*/
        site: '彭祖世家网',
        style: '201',
        width: 32,
        height: 32
      }
      var s = []
      for (var i in p) {
        s.push(i + '=' + encodeURIComponent(p[i] || ''))
      }
      var url = 'http://connect.qq.com/widget/shareqq/index.html?' + s.join('&')
      window.open(url, '_blank')
    },
    wx: function() {
      const qrcode = new QRCode('qrcode', {
        text: window.location.href,
        width: 100,
        height: 100,
        colorDark: '#000', // 黑色
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.H
      })
      qrcode.makeCode(window.location.href)// 生成另一个新的二维码
    },
    gopinlun: function() {
      if (!this.getLoca('userid')) {
        this.$emit('showlogin')
      }
    },
    goshowcang: function() {
      if (this.getLoca('userid')) {
        var obj = {}
        obj.userId = this.getLoca('userid')
        obj.contentId = this.$route.query.contentId
        addCollect(obj).then(res => {
          if (res.data === true) {
            if (this.iscollect) {
              this.$message({
                message: '取消收藏成功',
                type: 'success'
              })
              this.list.cmsCollectionNumber = this.list.cmsCollectionNumber - 1
            } else {
              this.$message({
                message: '收藏成功',
                type: 'success'
              })
              this.list.cmsCollectionNumber = this.list.cmsCollectionNumber * 1 + 1
            }
            this.iscollect = !this.iscollect
          }
        })
      } else {
        this.$emit('showlogin')
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .iframeSty{
    width:833px;
    height:800px;
    margin-top:45px;
  }
  .bookShow{
    padding: 0 20px;
    margin-top: 40px;
  }
  .Booktitle{
    margin-bottom: 20px;
    padding-bottom: 5px;
    border-bottom: 2px solid #e5e5e5;
    span{
      display: inline-block;
      padding-left: 7px;
      height: 20px;
      border-left: 2px solid #ed4040;
      font-size: 16px;
      line-height: 20px;
    }
  }
  .smallImg{
    overflow: hidden;
    margin-top: 20px;
      img{
        width: 100%;
        height: auto;
      }
  }
  .goback{
    position: absolute;
    top: 50px;
    left: 80%;
    svg{
      font-size: 60px;
      color: #a19d9e;
      cursor: pointer;
      &:hover{
        color: #333333;
      }
    }
  }
  .readBtn{
    padding-left: 10px;
    border-left: 1px solid #a19d9e;
    height: 20px;
    line-height: 20px;
  }
  .showBox{
    position: fixed;
    width: 100%;
    height: 100vw;
    background-color: rgba(0,0,0,.3);
    z-index: 15;
    display: block;
    top: 0;
    left: 0;
    .content{
      background-color: #fff;
      width: 432px;
      height: 630px;
      margin: 0 auto;
      margin-top: 30px;
      position: relative;
      .content_msg{
        overflow: hidden;
        .imgBox{
          width: 432px;
          height: 268px;
          font-size: 0;
          img{
            width: 432px;
            height: 268px;
          }
        }
        .title{
          font-size: 27px;
          color: #333333;
          font-weight: 500;
          text-align: center;
          margin:20px 0;
          height: 72px;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        p{
          display:-webkit-box;
          -webkit-line-clamp:3;
          -webkit-box-orient:vertical;
          overflow:hidden;
          word-break: break-all;
          padding: 0 20px;
          font-size: 18px;
          color: #a19d9e;
          line-height: 25px;
          height: 75px;
          margin-bottom: 20px;
          text-align: center;
        }
        .content_foot{
          border-top: 1px dashed #a19d9e;
          padding-top: 20px;
          font-size: 0;
          height: 130px;
          background-color: #fff;
          .logo_img{
            width: 173px;
            height: 56px;
            display: inline-block;
            vertical-align: top;
            margin-right: 86px;
            margin-top: 30px;
            margin-left: 29px;
          }
        }
      }
      .closeBtn{
        position: absolute;
        bottom: -25px;
        left: 191px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #ffffff;
        line-height: 50px;
        text-align: center;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
  #qrcode5{
    display: inline-block;
  }
  .moreShare{
    display: inline-block!important;
    vertical-align: top;
    height: 50px;
    line-height: 50px;
    a{
      background-image: none;
      margin-top: 18px;
      color: #FF6357;
      font-size:18px;
    }
  }
  .wxImg{
    position: relative;
    &:hover > #qrcode{
      display: inline-block;
      top: -102px;
      left:-43px;
    }
  }
  #qrcode{
    top: -102px;
    background-color: #fff;
    display: none;
    position: absolute;
    z-index: 5;
    left:-50px;
    p{
      height: 20px!important;
      line-height: 20px!important;
      font-size: 12px;
      text-align: center;
      position: absolute;
      bottom: -20px;
      left: 0;
      width: 100%;
      -moz-box-shadow:1px 1px 3px #f3f3f3;
      -webkit-box-shadow:1px 1px 3px #f3f3f3;
      box-shadow:1px 1px 3px #f3f3f3;
    }
  }
  .crumbs{
    height: 40px;
    line-height: 40px;
    border: 1px solid #e5e5e5;
    padding-left: 10px;
    color: #808080;
    background-color: #fff;
    margin-bottom: 20px;
    .lanmu{
      color:#ed4040;
      cursor: pointer;
    }
  }
  .box{
    background-color: #fff;
    border: 1px solid #e5e5e5;
    .center{
      overflow: hidden;
      padding: 20px 20px;
      background-color: #fff;
      .title{
        font-size: 27px;
        color: #fff;
        font-weight: 500;
        position: absolute;
        z-index: 2;
        top: 30px;
        left: 20px;
      }
      .contentMsg{
        font-size: 12px;
        color: #fff;
        margin-top: 10px;
        position: absolute;
        top: 70px;
        left: 20px;
        z-index: 2;
        .author{
          margin: 0 20px;
        }
      }
      .abstract{
        padding: 20px;
        margin-top: 20px;
        color: #fff;
        font-size: 14px;
        position: absolute;
        z-index: 2;
        top: 100px;
        left: 0;
        text-align: left;
        width: 798px;
        border-top: 1px dashed hsla(0,0%,100%,.4);
      }
      .imgBox{
        margin: 20px auto;
        text-align: center;
        height: 280px;
        overflow: hidden;
        position: relative;
        .shadowss{
          position: absolute;
          height: 280px;
          top: 0;
          left: 0;
          width: 100%;
          background-color: rgba(0,0,0,.8);
          z-index: 1;
        }
      }
      .content{
        font-size: 16px;
        color: #4d4d4d;
        margin-top: 30px;
        p{
          height: 20px;
          margin-top: 20px;
        }
        .ziliao{
          margin-left: 5px;
        }
        .download{
          color: #ed4040;
          margin-left: 5px;
        }
        .tagbox{
          margin-top: 20px;
        }
      }
    }
    .share{
      height: 52px;
      border-bottom:  1px solid #e5e5e5;
      border-top:  1px solid #e5e5e5;
      line-height:52px;
      width: 878px;
      position: fixed;
      bottom: 0;
      background-color: #fff;
      z-index: 9999;
      .btn{
        margin-left: 5px;
        &:hover{
          color: #ed4040;
          cursor: pointer;
        }
      }
      .star{
        display: inline-block;
        float: right;
      }
      span{
        display: inline-block;
        color: #FF6357;
        margin-left: 20px;
        svg{
          font-size: 18px;
          cursor: pointer;
          &:hover{
            color: #ed4040;
          }
        }
        i{
          font-size: 18px;
          cursor: pointer;
          &:hover{
            color: #ed4040;
          }
        }
      }
      .rightbox{
        float: right;
        display: inline-block;
        height: 52px;
        padding: 0 10px;
        .btnLoad{
          display: inline-block;
          margin-left: 10px;
          svg{
            color: #FF6357;
            font-size: 20px;
            &:hover{
              color: #ed4040;
            }
          }
        }
        .num{
          margin-left: 5px;
        }
        .collected {
          svg {
            color: #ed4040;
          }
        }
        .nocollected{
          svg{
            color: #ccc;
          }
        }
      }
    }
    .gonext{
      margin-top: 20px;
      margin-bottom: 20px;
      .next{
        display: inline-block;
        width: 410px;
        height: 86px;
        margin-left: 20px;
        position: relative;
        font-size: 0;
        color: #333;
        cursor: pointer;
        vertical-align: top;
        .imgbox{
          /*max-width: 100%;*/
          width: 410px;
          height: 0;
          padding-bottom: 20%;
          /*background-color:#ffffff;!*背景色*!*/
          overflow: hidden;
          img{
            width: 100%;
            margin-top: -50px;
          }
        }
        .imgShadow{
          width: 410px;
          height: 83px;
          position: absolute;
          top: 0;
          z-index: 5;
          background-color:rgba(0,0,0,.3);
          &:hover{
            background-color:rgba(0,0,0,0);
          }
        }
        .title{
          height: 38px;
          overflow: hidden;
          position: absolute;
          top: 15px;
          left: 15px;
          z-index: 6;
          color: #ffffff;
          font-weight: 600;
        }
        .time{
          color: #ffffff;
          z-index: 6;
          width: 100%;
          width: 385px;
          position: absolute;
          top: 60px;
          left: 0;
          padding-left: 15px;
          padding-bottom: 10px;
          .goelse{
            cursor: pointer;
            &:hover{
              color: #ed4040;
            }
          }
          .times{
            float: right;
          }
        }
      }
    }
    .likes{
      display: none;
      margin: 9px 0;
      margin-top: 20px;
      .title{
        margin: 0 20px;
        padding-bottom: 5px;
        border-bottom: 1px solid #e5e5e5;
        span{
          display: inline-block;
          padding-left: 7px;
          height: 20px;
          border-left: 2px solid #ed4040;
          font-size: 16px;
          line-height: 20px;
        }
      }
      .content{
        display: inline-block;
      }
    }
  }
  .box .center .imgBox{
    height: 210px;
    .shadowss{
      height: 210px;
      background-color: rgba(0, 0, 0, 0.7);
    }
    .title{
      text-align: left;
      top: 10px;
      height: 72px;
      overflow: hidden;
    }
    .contentMsg{
      top: 80px;
    }
    .abstract{
      width: auto;
      padding: 0;
      padding-top: 10px;
      height: 60px;
      overflow: hidden;
      padding-left: 20px;
    }
  }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .iframeSty{
      width:100%;
      height:550px;
      margin-top:45px;
    }
    .box{
      .gonext{
        .next{
          display: block;
          width: auto;
          margin: 10px 20px;
          overflow: hidden;
          .time{
            width: 100%;
            box-sizing: border-box;
            padding: 0 15px 10px;
          }
          .imgbox{
            height: 9px;
          }
          .imgShadow{
            width: 100%;
          }
        }
      }
      .share{
        display: none;
      }
    }
  }
</style>
